<template>
    <div id="code-message" class="container">
        <div class="row">
            <div class="wrap-message">
                <p>
                    <slot></slot>
                </p>
            </div>
        </div>
        <!---->
    </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
@import "@/assets/scss/_common.scss";

#code-message{
    .wrap-message{
        width: 100%;
        text-align: center;

        p{
            display: inline-block;
            background-color: #ededed;
            margin: 10px;
            padding: 10px;
            border-radius: 8px;
            color: #0D1D30;
        }
    }
}

</style>